export const companyAdminKeys = {
  getConfigsByType: (companyId: string, configType: string) => [
    'company-configs',
    companyId,
    configType,
  ],
};

export const suggestionContactsKeys = {
  getSuggestionContacts: ({ companyId }: { companyId: string }) => [
    'suggestion-contacts',
    companyId,
  ],
};
